/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Warm_Rust_Owl_PeekInputs */

const en_warm_rust_owl_peek = /** @type {(inputs: Warm_Rust_Owl_PeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} round(s) disabled`)
};

const de_warm_rust_owl_peek = /** @type {(inputs: Warm_Rust_Owl_PeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Runde(n) deaktiviert`)
};

/**
* | output |
* | --- |
* | "{count} round(s) disabled" |
*
* @param {Warm_Rust_Owl_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_rust_owl_peek = /** @type {((inputs: Warm_Rust_Owl_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Rust_Owl_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_rust_owl_peek(inputs)
	return de_warm_rust_owl_peek(inputs)
});